
import { LetterTextIcon } from "lucide-react";
import { GpsBaseURL, uniqueToken } from "../api/DataApis";
import request from "./request";

export const fetchLoginApi = async (mobile) => {
    const registrationApi = `${GpsBaseURL}/web/user/auth/register`;

    try {
        let res = await request({
            url: registrationApi,
            method: "POST",
            data: { mobile },
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Accept: "application/json",
            },
        });

        return res;  // 👈 Directly return the response instead of `res.data`
    } catch (error) {
        console.error("Error in registration:", error);
    }

    return [];
};

export const fetchRegisterApi = async (userData, userID) => {
  try {
    console.log("userData", userData);
    // const registrationApi = `${GpsBaseURL}/web/user/profile-update`;
    
    var registrationApi;
    if(userID) {
      registrationApi =  `${GpsBaseURL}/web/user/profile-update/${userID}`;
    } else {
      registrationApi =  `${GpsBaseURL}/web/user/profile-update`;
    }

    // 🆕 Create FormData for file uploads
    const formData = new FormData();
    formData.append("name", userData?.name || "");
    formData.append("email", userData?.email || "");
    formData.append("address", userData?.address || "");
    formData.append("pin_code", userData?.pin_code || "");
    formData.append("mobile", userData?.mobile || "");
    formData.append("district", userData?.district || "");
    //formData.append("bc_corporate_name", userData?.bc_corporate_name || "");
    formData.append("company_id", userData?.company_id || "");

    if (userData.mobile_profile_image) {
      formData.append("mobile_profile_image", userData?.mobile_profile_image); // 🆕 Add profile image
    }
    formData.append("countryId", userData?.country?._id || "");
    formData.append("stateId", userData?.state?._id || "");
    formData.append("cityId", userData?.city || "");
    formData.append("bc_agent_id", userData?.bc_agent_id || "");
    formData.append("corporate_id", userData?.corporate_id || "67b57bffb67277a8a6f79b6c");
    formData.append("bc_corporate_name", userData?.bc_corporate_name || "");
    
    // 🆕 API Request with Error Handling
    const res = await request({
      url: registrationApi,
      method: "PUT",
      data: formData, // ✅ Use FormData instead of JSON
      headers: {
        "Content-Type": "multipart/form-data", // ✅ Required for file uploads
        Accept: "application/json",
      },
    });

    // 🆕 Check for API errors (if API returns error messages)
    if (!res || res.statusCode >= 400) {
      throw new Error(res?.message || "Registration failed. Please try again.");
    }

    return res; // ✅ Return successful response
  } catch (error) {
    console.error("Error in registration:", error);

    // 🆕 Extract meaningful error messages
    let errorMessage = "An error occurred. Please try again.";
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      errorMessage = Array.isArray(errorData.message)
        ? errorData.message.join("\n") // If multiple errors, join them into one message
        : errorData.message || errorMessage;
    }

    // 🆕 Return error object instead of `null`
    return {
      success: false,
      error: errorMessage,
    };
  }
};


  
export const fetchOtpVerificationApi = async (otp) => {
    console.log("uniqueToken", uniqueToken);
    
    const registrationApi = `${GpsBaseURL}/web/user/otp-verify`;

    try {
        let res = await request({
            url: registrationApi,
            method: "PUT",
            data: { otp },
            headers: {
               
                Accept: "application/json",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        return res;  // 👈 Directly return the response instead of `res.data`
    } catch (error) {
        console.error("Error in verification:", error);
    }

    return [];
};